import { render } from "./Single.vue?vue&type=template&id=9496b6c0&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"

import "./Single.vue?vue&type=style&index=0&id=9496b6c0&scoped=true&lang=css"

import exportComponent from "/var/www/kosamba-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9496b6c0"]])

export default __exports__